import React from 'react';

export default function ListIcon({src, alt}: {
    src: string,
    alt: string,
}) {
    return <img src={src} alt={alt} className="models-list__content-table__icon"/>;
}
